import { BaseFetch } from "../main-model"
export default class InsigniaModel extends BaseFetch {
    getInsigniaBy = (data) =>
        this.authFetch({
            url: "insignia/getInsigniaBy",
            method: "POST",
            body: JSON.stringify(data),
        })
    getInsigniaById = (data) =>
        this.authFetch({
            url: "insignia/getInsigniaById",
            method: "POST",
            body: JSON.stringify(data),
        })
    updateInsigniaById = (data) =>
        this.authFetch({
            url: "insignia/updateInsigniaById",
            method: "POST",
            body: JSON.stringify(data),
        })
    insertInsignia = (data) =>
        this.authFetch({
            url: "insignia/insertInsignia",
            method: "POST",
            body: JSON.stringify(data),
        })
    deleteInsigniaById = (data) =>
        this.authFetch({
            url: "insignia/deleteInsigniaById",
            method: "POST",
            body: JSON.stringify(data),
        })
}
